import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import { INITIAL_DATA_CREATE, tableConfigCreate } from "../config";
import { contructPayloadSubmit, validateDataTable } from "../util";
import ReceivingInputGift from "./receivingInputGift";
import { flattenFormGroupObject } from "../../../../common/mapper";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class ReceivingGiftCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      dataHadiah: [],
      dataLocator: [],
      tempSPBH: null,
      dataHadiahFiltered: [],
      pagination: {
          page: 1,
          limit: 5,
          totalData: 0,
      },
    };
  }

  componentDidMount() {
    this.loadDDL();
  }

  handleSelectKodeHadiah = (index, name, value) => {
    this.handleSetTableValue(index, name, value);
    this.handleSetTableValue(index, "kategori", value?.categoryHadiah);
    this.handleSetTableValue(index, "namaHadiah", value?.nameHadiah);
    this.handleSetTableValue(index, "satuan", value?.satuanHadiah);
  };

  handleSetTableValue = (index, name, value) => {
    this.setState((prev) => {
      const newData = [...prev.dataTable];
      newData[index] = {
        ...newData[index],
        [name]: value,
      };
      return {
        ...prev,
        dataTable: newData,
      };
    });
  };

  handleChangeAllLocator = (value) => {
    this.setState((prev) => ({
      ...prev,
      dataTable: prev.dataTable.map((row) => {
        if (!row.saved) {
          return {
            ...row,
            locator: value,
          };
        }
        return row;
      }),
    }));
  };

  handleDeleteRow = (index) => {
    this.setState((prev) => ({
      ...prev,
      dataTable: [...prev.dataTable.filter((_, idx) => idx !== index)],
    }));
  };

  handleOpenKodeHadiah = () => {
    this.setState((prev) => ({
      ...prev,
      dataHadiahFiltered: prev?.dataHadiah?.filter(
        (item) =>
          !prev?.dataTable
            ?.map((item) => item.kodeHadiah?.value)
            ?.includes(item.value)
      ),
    }));
  };

  getTableConfig = () => {
    const { dataHadiah, dataLocator, dataTable, dataHadiahFiltered } =
      this.state;
    return tableConfigCreate({
      dataHadiah:
        dataHadiahFiltered.length > 0 ? dataHadiahFiltered : dataHadiah,
      onKodeHadiahChange: this.handleSelectKodeHadiah,
      dataLocator: dataTable.length > 0 ? dataLocator : [],
      onChangeAllLocator: this.handleChangeAllLocator,
      onDeleteRow: this.handleDeleteRow,
      onTableValueChange: this.handleSetTableValue,
      onSaveRow: this.handleSetTableValue,
      dataTable: dataTable,
      openKodeHadiah: this.handleOpenKodeHadiah,
    });
  };

  handleAddRow = (tab) => {
    this.setState((prevValue) => ({
      ...prevValue,
      dataTable: [...prevValue.dataTable, INITIAL_DATA_CREATE],
    }));
  };

  loadDDL = async () => {
    const { setError, selectedCabang, onTriggerLoading } = this.props;

    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllHadiah,
        menuName: "Receiving Gift",
        setError: setError,
        args: null,
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA")
          .getAllMasterLocationPagingByParam,
        menuName: "Receiving Gift",
        setError: setError,
        args: {
          paramFilters: { kodeCabang: selectedCabang?.value },
          page: null,
          limit: null,
        },
      }),
    ];

    onTriggerLoading();
    const res = await Promise.all(promises);
    onTriggerLoading();
    if (res[0].ok && res[0].data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataHadiah: res[0].data.data?.map((item) => {
          return {
            label: item.kodeHadiah,
            value: item.kodeHadiah,
            ...item,
          };
        }),
      });
    }

    if (res[1].ok && res[1].data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataLocator: res[1].data.data?.map((item) => {
          return {
            label: item.nameLocation,
            value: item.kodeLocation,
            kodeCabang: item.kodeCabang,
          };
        }),
      });
    }
  };

  handleClear = () => {
    const { resetIgnoreKeys, setValue } = this.props;
    resetIgnoreKeys(["spbhNo"]);
    setValue("spbhDate", moment().format("DD-MM-YYYY"));
    this.setState((prevState) => ({
      ...prevState,
      dataTable: [],
    }));
  };

  handleSubmit = () => {
    const { selectedCabang, controls, onSubmit } = this.props;
    const { dataTable } = this.state;
    const validateDetail = validateDataTable(dataTable);
    if (!this.props.validate() || !validateDetail) {
      this.props.onChangeAlertInfo(
        "Informasi",
        <p>
          Ada field data yang perlu diisi atau tidak sesuai kriteria isian.
          <br />
          Mohon periksa kembali
        </p>
      );
      return;
    }
    const payload = contructPayloadSubmit({
      ...flattenFormGroupObject(controls),
      kodeCabang: selectedCabang,
      dataTable,
    });

    onSubmit(payload, "save");
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { dataTable, tempSPBH } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Tambah Penerimaan Hadiah"
          visible={visible}
          styles={{ width: "80%" }}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <ReceivingInputGift {...this.props} tempSPBH={tempSPBH} />
              <div style={{ marginBottom: "20px" }}>
                <h3 className="margin-bottom-10px">Hadiah</h3>
              </div>

              <FlexView column style={{ gap: "15px" }}>
                <SimpleButton
                  className={"btn btn-plus background-red"}
                  onClick={() => this.handleAddRow()}
                  style={{ width: 145, marginLeft: "0px" }}
                  icon={<i className="fa fa-plus margin-right-10px"></i>}
                  text={"Tambah Hadiah"}
                />
                <SimpleDataTable
                  key={`${dataTable.length}-${this.state.pagination.page}`}
                  data={dataTable}
                  columns={this.getTableConfig()}
                  toCount={dataTable.length}
                  rowsPerPage={this.state.pagination.limit}
                  page={this.state.pagination.page - 1}
                  options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                />
              </FlexView>
              <FlexView
                vAlignContent="bottom"
                hAlignContent="right"
                style={{ marginTop: "20px" }}
              >
                <SimpleButton
                  type="button"
                  text="Clear"
                  onClick={this.handleClear}
                />
                <SimpleButton
                  type="button"
                  text="Simpan"
                  onClick={() => this.handleSubmit()}
                />
                <SimpleButton
                  type="button"
                  text="Batal"
                  onClick={() => onClickClose()}
                />
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default withFormGroup(ReceivingGiftCreate);
